import React from 'react';
import { Heart, UserCircle2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ScrollArea } from '@/components/ui/scroll-area';

import InfoIcon from './InfoIcon';
import ScopeDot from './ScopeDot';

const RelationshipsCompact = ({ relationships, count, navigate }) => {
  const top3 = (relationships || []).slice(0, 3);
  return (
    <Card data-testid="relationships-compact">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium flex items-center justify-between">
          <span className="flex items-center gap-1.5">
            <Heart className="w-4 h-4" />
            A cultivar
            <InfoIcon text="Contactos que han superado su umbral de días sin contacto según la cadencia asignada." testid="info-relationships" ariaLabel="Información sobre A cultivar" />
          </span>
          {count > 0 && <Badge variant="secondary" className="text-xs">{count}</Badge>}
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        {top3.length === 0 ? (
          <p className="text-xs text-muted-foreground">Al día.</p>
        ) : (
          <>
            <ScrollArea className="h-[140px]">
              <div className="space-y-0.5">
                {(relationships || []).map((r, idx) => (
                  <button
                    key={`${r.type}-${r.id}`}
                    type="button"
                    onClick={() => navigate(r.type === 'contact' ? `/contacts/${r.id}` : `/companies/${r.id}`)}
                    className="w-full flex items-center gap-2 px-1.5 py-1 rounded hover:bg-muted/60 text-left"
                    data-testid={`relationship-compact-${idx}`}
                  >
                    <UserCircle2 className="w-3.5 h-3.5 text-pink-500 flex-shrink-0" />
                    <div className="flex-1 min-w-0">
                      <p className="text-xs font-medium truncate flex items-center">
                        <ScopeDot scope={r.scope} />
                        <span className="truncate">{r.name}</span>
                      </p>
                      <p className="text-[9px] text-muted-foreground truncate">{r.role || r.status || ''}</p>
                    </div>
                    <span className="text-[9px] text-orange-600 font-medium whitespace-nowrap">
                      {r.days_since_contact == null ? 'Nuevo' : `${r.days_since_contact}d`}
                    </span>
                  </button>
                ))}
              </div>
            </ScrollArea>
            {count > (relationships || []).length && (
              <button
                type="button"
                onClick={() => navigate('/contacts')}
                className="text-[10px] text-muted-foreground hover:text-primary mt-1 w-full text-right"
              >
                Ver todos ({count}) →
              </button>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default RelationshipsCompact;
